/**
 * Moeda como objeto de valor.
 *
 * O que importa aqui é `casas`: nem toda moeda tem centavos. CLP e PYG têm zero
 * (spec 02 §1.5), e arredondar um peso chileno para duas casas inventa dinheiro
 * que não existe. Por isso o arredondamento de `Money` pergunta à moeda, em vez de
 * assumir 2.
 *
 * O domínio NÃO carrega o catálogo de moedas: quem o carrega é a borda, a partir da
 * tabela `moeda`. Se a lista das sete moedas do seed estivesse escrita aqui, o
 * mesmo dado passaria a existir em dois lugares — e um dia divergiriam.
 */

export interface Moeda {
  readonly iso: string
  readonly casas: number
}

export class MoedaInvalida extends Error {
  constructor(mensagem: string) {
    super(mensagem)
    this.name = 'MoedaInvalida'
  }
}

/** Constrói uma moeda validando o que o schema já exige (spec 02 §1.5). */
export function moeda(iso: string, casas: number): Moeda {
  if (!/^[A-Z]{3}$/.test(iso)) {
    throw new MoedaInvalida(`ISO de moeda deve ter 3 letras maiúsculas: recebi "${iso}"`)
  }
  if (!Number.isInteger(casas) || casas < 0 || casas > 4) {
    throw new MoedaInvalida(`casas decimais de ${iso} fora do intervalo 0–4: recebi ${String(casas)}`)
  }
  return { iso, casas }
}

export function mesmaMoeda(a: Moeda, b: Moeda): boolean {
  return a.iso === b.iso
}
